import React from 'react'
import { minorScale, majorScale, defaultTheme } from 'evergreen-ui'
import CircleIconWrapper from 'components/Icons/CircleIconWrapper'
import OriginalCatalogIcon from 'components/Icons/Catalog'

const CatalogIcon = () => (
  <CircleIconWrapper
    background="greenTint"
    margin={0}
    size={majorScale(3)}
    icon={
      <OriginalCatalogIcon
        size={minorScale(3)}
        fill={defaultTheme.palette.green.base}
      />
    }
  />
)

export default CatalogIcon
